import axios, { AxiosResponse } from "axios";
import { CoberturaPoliza, CreatePolizaDTO, monedaOrigenDto, UpdatePoliza } from "../models/polizaSeguro";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";




const getCoberturas = async (codigoPoliza?: string) => {
    const response: AxiosResponse<ListResponseDto<CoberturaPoliza>> = await axiosInstance.get(`siscred-api-maestros/v1/polizaseguro/lista-cobertura`, {
        params: { codigoPoliza: codigoPoliza }
    });
    return response.data.items;
}

const getDetallePoliza = async (codigo: string) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-maestros/v1/polizaseguro/detalle`, {
        params: { codigoPoliza: codigo }
    });
    return response;
};
const crearPoliza = async (data: CreatePolizaDTO) => {    
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/polizaseguro/crear`, data);
    return response;

};

const actualizarPoliza = async (data: UpdatePoliza) => {
    const response: AxiosResponse = await axiosInstance.put(`siscred-api-maestros/v1/polizaseguro/actualizar/${data.codigo}`, data);
    return response;
};

const crearCobertura = async (data: CoberturaPoliza) => {    
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/polizaseguro/crear-cobertura`, data);
    return response;

};

const actualizarCobertura = async (data: CoberturaPoliza) => {
    const response: AxiosResponse = await axiosInstance.put(`siscred-api-maestros/v1/polizaseguro/actualizar-cobertura/${data.polizaCodigo}`, data);
    return response;
};

const deleteCoberutura = async (codigo: string) => {
    const response: AxiosResponse = await axiosInstance.delete(`siscred-api-maestros/v1/polizaseguro/eliminar-cobertura/${codigo}`);
    return response;
};

const deletePoliza = async (codigo: string) => {
    const response: AxiosResponse = await axiosInstance.delete(`siscred-api-maestros/v1/polizaseguro/eliminar/${codigo}`);
    return response;
}

const getMonedas = async () => {
    const response: AxiosResponse<ListResponseDto<monedaOrigenDto>> = await axiosInstance.get(`siscred-api-maestros/v1/polizaseguro/lista-moneda`);
    return response;
}

export {
getDetallePoliza,
crearPoliza,
actualizarPoliza,
crearCobertura,
actualizarCobertura,
deleteCoberutura,
deletePoliza,
getCoberturas,
getMonedas
}

